/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payabli/view.blocks to change it.
import Paypoints from './Paypoints/index'
import React from 'react'
import Token from './Token/index'
import TokenSetupInstructions from './TokenSetupInstructions/index'



/** @type {import('Simple/types.js').View} */
export default function Payabli({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Payabli"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Payabli.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Payabli.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Token
  viewPath={`${viewPath}/Token`}
/>
<Paypoints
  viewPath={`${viewPath}/Paypoints`}
/>
</div>
<TokenSetupInstructions
  viewPath={`${viewPath}/TokenSetupInstructions`}
/>
</div>
{children}
</React.Fragment>)
}